module.exports = __webpack_public_path__ + "img/close.a10da0ff.png";